import { styled, Switch } from "@mui/material";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { colorPrimary, colorSecondary } from "@/constants/colors";

const createSvgUrl = (faIcon: any, color: any) => {
	const [width, height, , , svgPathData] = faIcon.icon;

	const svg = `
		<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
			<path fill="${color}" d="${svgPathData}"/>
		</svg>
	`;

	return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
};

export const SwitchWithIconsRoot = styled(Switch)(({ theme }) => ({
	padding: 0,
	height: 20,
	width: 40,

	"& .MuiSwitch-root": {
		padding: "0 !important",
	},
	"& .MuiTouchRipple-root": {
		padding: 0,
		height: 16,
	},

	"& .MuiSwitch-switchBase": {
		padding: 0,
	},
	"& .MuiSwitch-track": {
		borderRadius: 22 / 2,
		position: "relative",
		backgroundColor: colorPrimary,
		opacity: 1,

		"&::before, &::after": {
			content: '""',
			position: "absolute",
			top: "50%",
			transform: "translateY(-50%)",
			width: 14,
			height: 14,
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
		},
		"&::before": {
			backgroundImage: createSvgUrl(faCheck, theme.palette.getContrastText(theme.palette.primary.main)),
			left: 5,
		},
		"&::after": {
			backgroundImage: createSvgUrl(faXmark, theme.palette.getContrastText(theme.palette.primary.main)),
			right: 3,
		},
	},

	"& .Mui-checked + .MuiSwitch-track": {
		backgroundColor: colorSecondary,
		opacity: "1 !important",
	},

	"& .MuiSwitch-thumb": {
		boxShadow: "none",
		width: 16,
		height: 16,
		margin: "2px",
		color: "#fff",
	},

	"&.Mui-disabled .MuiSwitch-thumb": {
		backgroundColor: colorPrimary,
		opacity: 1,
	},
}));
